import { IWarehouseLocation } from "../../models/Location";

export default function WarehouseLocationCapacity({ location }: { location: IWarehouseLocation }) {
  var color = location.capacity == 0 ? "text-gray-800" : "text-green-800";
  if ((location.occupied ?? 0) >= (location.capacity ?? 0)) {
    color = "text-red-600";
  } else if ((location.occupied ?? 0) >= 0.8 * (location.capacity ?? 0)) {
    color = "text-yellow-600";
  }

  return (
    <span className={`${color}`}>
      {location.occupied ?? 0} / {location.capacity ?? 0}
    </span>
  );
}